module.exports = __webpack_public_path__ + "img/AFEM.fbab2b05.svg";